import { getCurrentDateInSeconds } from "../../../../../shared/functions/getRandomId";
import { validateEmail } from "../../../../../shared/functions/validateEmail";
import axios from "axios";

interface IDataFetch {
    (payment: any, amount: number): { createUrl: string; methodId: string } | null;
}

const showToast = (setToastProps, message, type = "error") => {
    setToastProps({ message, type, id: getCurrentDateInSeconds() });
};

const getValidEmail = (email, placeholder) => {
    if (validateEmail(email)) return email;
    if (validateEmail(placeholder)) return placeholder;
    return null;
};

export const createPayment = async (
    depositAmount,
    paymentMethod,
    setToastProps,
    setActivePopup,
    setActivePopupNotFully,
    email, setEmail,
    user,
    emailPlaceholder,
    setOnBlurLoad
) => {
    if (depositAmount < paymentMethod.min) {
        return showToast(setToastProps, `Мінімальний платіж цим методом - ${paymentMethod.min} ${paymentMethod.iconCurrency}`);
    }

    if (paymentMethod.paymentSystem === "BuyMeACoffee") {
        setActivePopup(false);
        setActivePopupNotFully(true);
        return;
    }

    const validEmail = getValidEmail(email, emailPlaceholder);

    if (!validEmail) {
        if (!validateEmail(email)) setEmail(user.email);
        return showToast(setToastProps, "Введіть коректну електронну адресу", "warning");
    }

    setOnBlurLoad(true);

    const dataFetch: IDataFetch = function (payment, amount) {
        if (typeof payment.createUrl === "string") {
            return {
                createUrl: payment.createUrl,
                methodId: payment.preferMethod,
            };
        }

        if (typeof payment.createUrl === "object") {
            for (const [key, method] of Object.entries(payment.preferMethod)) {
                if (amount < method.limit) {
                    return {
                        createUrl: payment.createUrl[key],
                        methodId: method.methodId,
                    };
                }
            }
        }

        return null;
    };

    // true, коли ми вже перенаправляємо гравця на платіжну сторінку: спінер лишається до зміни сторінки
    let redirecting = false;

    try {
        const dataForPayment = dataFetch(paymentMethod, depositAmount)

        if(!dataForPayment) {
            return
        }
        const response = await axios.post(
            dataForPayment.createUrl,
            {
                payload: {
                    amount: depositAmount,
                    prefer_methods: [dataForPayment.methodId],
                    customer: { email: validEmail },
                    currency: paymentMethod.currency,
                    paymentSystem: paymentMethod.paymentSystem
                }
            },
            { withCredentials: true }
        );

        const { payment_url } = response.data;
        if (payment_url) {
            redirecting = true;
            window.location.href = payment_url;
        }
    } catch (error) {
        console.error("Error creating payment:", error);
        showToast(setToastProps, "Сталася помилка під час створення платежу");
    } finally {
        if (redirecting) {
            // Страховка: якщо гравець повернеться кнопкою «Назад» (сторінка відновиться з кешу), спінер не має лишитись
            setTimeout(() => setOnBlurLoad(false), 2000);
        } else {
            setOnBlurLoad(false);
        }
    }
};
